import { Injectable } from "@angular/core";
import { Area } from "../../../../shared/Models/read/Area";
import { Building } from "../../../../shared/Models/read";

@Injectable({
  providedIn: "root",
})
export class SessionService {
  constructor() {}

  getBlockAddress() {
    if (
      sessionStorage.getItem("city") &&
      sessionStorage.getItem("city") != "null"
    ) {
      const selectedCity = sessionStorage.getItem("city");
      const selectedFiberHood: Area = this.getFiberhood();
      const selectedBlock: Area = this.getBlock();
      const fullBlockAddress = [
        selectedCity,
        selectedFiberHood.fiberHood,
        selectedBlock.block,
      ].join(" | ");

      return fullBlockAddress;
    }
    return null;
  }

  getFiberhood() {
    const fiberhoodString = sessionStorage.getItem("fiberhood");
    const selectedFiberHood: Area = fiberhoodString
      ? JSON.parse(fiberhoodString)
      : null;
    return selectedFiberHood;
  }

  getBlock() {
    const blockString = sessionStorage.getItem("block");
    const selectedBlock: Area = blockString ? JSON.parse(blockString) : null;
    return selectedBlock;
  }

  setLocation(building: Building) {
    const selectedBlock: Area = building.block;
    const selectedFiberhood: Area = building.fiberhood;

    sessionStorage.setItem("city", building.block.city);
    sessionStorage.setItem("areaId", building.block.id);
    sessionStorage.setItem("block", JSON.stringify(selectedBlock));
    sessionStorage.setItem("fiberhood", JSON.stringify(selectedFiberhood));
  }

  clearLocation() {
    sessionStorage.removeItem("city");
    sessionStorage.removeItem("areaId");
    sessionStorage.removeItem("block");
    sessionStorage.removeItem("fiberhood");
  }

  clearAll() {
    this.clearLocation();
    sessionStorage.removeItem("lastSurveyIndex");
    sessionStorage.removeItem("buildingListFilterStorage");
  }
}
